import { gql } from 'urql';

const FetchUser = gql`
  fragment UserCardFragment on Card {
    __typename
    id
    type
    status
    maskedCardNumber
    isLocked
    isPinSet
    changePinOptions
    associatedAccountIds
    digital
    actions
    shippingInformation: shippingInformationV2 {
      __typename
      arrivalMessage
    }
  }

  fragment UserAccountFragment on Account {
    __typename
    id
    type
    product
    status
  }

  fragment CustomerInfoFragment on CustomerInfo {
    __typename
    id
    status
    canAccessCardService
    createdAt
    isAddressVerified
    ssnLastFour
    email {
      __typename
      address
    }
    name {
      __typename
      first
      last
    }
    phone
    dateOfBirth
    address {
      __typename
      addressLine1
      addressLine2
      city
      state
      zip
      country
    }
    userVoice {
      __typename
      redirectUrl
    }
    profilePhoto {
      __typename
      url
      hash
    }
  }

  query FetchUser {
    user {
      __typename
      id
      customerInfo {
        ...CustomerInfoFragment
      }
      accounts {
        ...UserAccountFragment
      }
    }
    cards(
      filter: { status: [NEW, ACTIVATED, LOCKED, NOT_ACTIVATED, SUSPENDED] }
    ) {
      __typename
      ...UserCardFragment
    }
  }
`;

export default FetchUser;
